import { render, staticRenderFns } from "./notRecommend.vue?vue&type=template&id=2a3077ab"
import script from "./notRecommend.vue?vue&type=script&lang=js"
export * from "./notRecommend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3077ab')) {
      api.createRecord('2a3077ab', component.options)
    } else {
      api.reload('2a3077ab', component.options)
    }
    module.hot.accept("./notRecommend.vue?vue&type=template&id=2a3077ab", function () {
      api.rerender('2a3077ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brokerManage/components/notRecommend.vue"
export default component.exports